import { render, staticRenderFns } from "./BulkUpdatePrices.vue?vue&type=template&id=a2f2187e&"
import script from "./BulkUpdatePrices.vue?vue&type=script&lang=js&"
export * from "./BulkUpdatePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports